var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(
      (_vm.isLogin &&
        Object.keys(_vm.dataProfile).length > 0 &&
        _vm.$store.state.finishFetch) ||
      !_vm.isLogin
    )?_c('div',{staticClass:"layout bg-app"},[_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e(),(_vm.$store.state.loading)?_c('loading'):_vm._e(),(_vm.$store.state.menuOpen)?_c('modal-menu'):_vm._e(),(_vm.$store.state.openAlert)?_c('alert-custom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }